export default __webpack_public_path__ + "static/media/how-it-works-4.99b153ee.png";